enum eStorageType {
    Local,
    Session
  }
export default eStorageType;
